export const ALL_SCORES = {
  ACTION_TYPES: {
    fetchCountryGames: 'fetchCountryGames',
    fetchCompetitionGames: 'fetchCompetitionGames',
    groupClick: 'groupClick',
    populateLiveData: 'populateLiveData',
    onLiveClick: 'onLiveClick',
    onSortClick: 'onSortClick',
    gameClick: 'gameClick',
    onDateChange: 'onDateChange',
    onOnTvShowOddsClick: 'onOnTvShowOddsClick',
    fetch: 'fetch',
  },
  ANALYTICS: {
    BOOKIE_CLICK_TYPES:{
      odds: 'odds',
      bookie: 'bookie'
    },
    GROUP_TYPE: {
      competition: 'competition',
      country: 'country',
      sport: 'sport'
    },
    SECTION: {
      all: 'all',
      popular: 'popular'
    },
    CLICK_TYPES: {
      open: 'open',
      close: 'close'
    },
    ARROW_CLICK_TYPES: {
      day: 'day',
      month: 'month'
    },
    ARROW_CLICK_DIRECTION: {
      backward: 'backward',
      forward: 'forward'
    },
    ACTION_TYPES: {
      onCalendarDisplay: 'onCalendarDisplay',
      onCalendarClick: 'onCalendarClick',
      onCalendarTodayClick: 'onCalendarTodayClick',
      onCalendarArrowClick: 'onCalendarArrowClick',
      onCalendarDateCellClick: 'onCalendarDateCellClick'
    }
  },

  ITEMS: {
    competition: 'competition',
    country: 'country'
  },

  STAGE_TYPE: {
    standings: 1,
    groups: 2,
    knockout: 3
  }
};
